import {Injectable} from "@angular/core";
import {ContactInfo} from "../objects/models/contact-info";
import {QuestionInterface} from "../objects/interfaces/questions & options/question.interface";
import {Router} from "@angular/router";
import {ApplicantInfo} from "../objects/interfaces/sessions/applicant-info";

@Injectable({providedIn: 'root'})
export class QuestionHandlerService {
  sessionId: string;
  applicantInfo: ApplicantInfo;
  questions: QuestionInterface[];
  timer: number = 30;
  contactInfo: ContactInfo;

  checkSession(router: Router){
    if (this.sessionId === undefined){
      router.navigate(['accessDenied']).then();
    }
  }

  checkQuestions(router: Router){
    if (this.questions === undefined){
      router.navigate(['accessDenied']).then();
    }
  }
}
